'use client';

import React, { useState } from 'react';
import { Search } from 'src/components/PulseUI';
import { TableExportMenu } from 'src/components/Tables';
import { TableColumnMenu } from 'src/components/Tables/components/TableColumnMenu';
import { RoundAddToListButton } from '../TableAddToListButton';

interface SitesToolbarProps {
  location?: string;
  onSearch?: (value: string) => void;
  // Pagination Header
  page?: number;
  pageSize?: number;
  rowCount?: number;
  // Export button props
  onExport?: (type: string) => void;
  isExporting?: boolean;
  isExportDisabled?: boolean;
  // Columns button props
  columns?: any[];
  columnVisibilityModel?: any;
  setColumnVisibility?: any;
  // Feature flags
  showExportButton?: boolean;
  showAddToListButton?: boolean;
  onClearSelection?: () => void;
}
const SitesToolbar = (params: SitesToolbarProps) => {
  const {
    showExportButton = false,
    showAddToListButton = false,
    location,
    onClearSelection,
    ...restParams
  } = params;

  const [search, setSearch] = useState('');

  const handleSearch = (value) => {
    setSearch(value);
    restParams?.onSearch?.(value);
  };

  const handleExport = (type: string) => {
    if (!type) return;
    restParams?.onExport?.(type);
  };

  return (
    <div data-property-1="Default" className="flex flex-col gap-2" data-testid="sites-toolbar">
      <div className="self-stretch flex justify-between items-center">
        <div className="flex justify-start items-end gap-2">
          <div className="w-64 inline-flex flex-col justify-start items-start gap-1">
            <div className="self-stretch justify-start text-text-primary text-xs font-semibold font-['Inter'] leading-none">
              Search
            </div>
            <Search
              value={search}
              onSearch={handleSearch}
              className="w-full rounded-full"
            />
          </div>
        </div>
        <div className="self-stretch flex justify-end items-end gap-2">
          {showAddToListButton && <RoundAddToListButton onClearSelection={onClearSelection} />}
          {showExportButton && (
            <TableExportMenu
              isExporting={restParams?.isExporting}
              table={location}
              onExport={handleExport}
              disabled={restParams?.isExportDisabled}
            />
          )}
          <TableColumnMenu
            table={location}
            columns={restParams?.columns}
            columnVisibilityModel={restParams?.columnVisibilityModel}
            setColumnVisibilityModel={restParams?.setColumnVisibility}
          />
        </div>
      </div>
      <div className="self-stretch px-2 pt-1 inline-flex justify-between items-center" data-testid="results-summary">
        <div className="flex-1 flex justify-start items-center gap-1">
          <div className="justify-start text-text-primary text-lg font-bold font-['Inter'] leading-7">
            Showing{' '}
            <span data-testid="showing-count">
              {Math.min(restParams?.pageSize || 10, restParams?.rowCount || 0)}
            </span>{' '}
            Results
          </div>
          <div className="justify-start text-text-primary text-lg font-normal font-['Inter'] leading-7">
            of <span data-testid="total-count">{restParams?.rowCount || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SitesToolbar;
